var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.67,
    height: 21.55,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4558 18.9424C16.4702 18.9424 19.7224 15.6083 19.7224 11.5C19.7224 7.39172 16.467 4.05761 12.4558 4.05761C8.44449 4.05761 5.18911 7.39172 5.18911 11.5H6.66912L3.83297 15.9563L1 11.5H2.36249C2.36567 5.79135 6.88191 1.16263 12.4558 1.16263C18.0296 1.16263 22.549 5.79135 22.549 11.5C22.549 17.2086 18.0296 21.8374 12.4558 21.8374V18.9424Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/Refund.f18642177db1ae351459bacfc8672137.svg";
export { ForwardRef as ReactComponent };